import React, { useState, useEffect } from "react";

import {
  Text,
  StyleSheet,
  View,
  TouchableOpacity,
  LayoutAnimation,
  Platform,
} from "react-native";

import Icons from "../../common/icons";
import CopyActivityItem from "./CopyActivityItem";
import Collapsible from "../../common/Collapsible/Collapsible";
import CollapseIcon from "../../common/icons/CollapseIcon";

CollapseIcon;

const PAGE_SIZE = 30;

export default function CopyActivitiesList(props) {
  const {
    title,
    activities,
    initialNumToRender,
    contentType = "activities",
    selectActivityTags,
    onSelectTag,
  } = props;

  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [activitiesList, setActivitiesList] = useState([]);
  const [message, setMessage] = useState("");
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    const results =
      contentType == "Favorites"
        ? activities.filter((a) => a.is_favorite == 1)
        : activities;

    if (hasMoreItems && results.length > initialNumToRender) {
      setActivitiesList(results.slice(0, initialNumToRender));
      setHasMoreItems(true);
      setMessage(results.length - initialNumToRender + ` more ${contentType}`);
    } else {
      setActivitiesList(results);
      setHasMoreItems(false);
    }
  }, [activities]);

  const showMore = () => {
    setActivitiesList(activities.slice(0));
    setHasMoreItems(false);
  };

  const toggleExpand = () => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setIsCollapsed(!isCollapsed);
  };

  return (
    <View>
      <TouchableOpacity onPress={toggleExpand}>
        <Text style={styles.header}>{title}</Text>
        <CollapseIcon style={styles.collapseIcon} isCollapsed={isCollapsed} />
      </TouchableOpacity>

      <Collapsible isCollapsed={isCollapsed}>
        <View style={styles.listContainer}>
          {activitiesList.map((item, index) => (
            <CopyActivityItem
              key={index}
              item={item}
              selectActivityTags={selectActivityTags}
              onSelectTag={onSelectTag}
            />
          ))}
          {hasMoreItems ? (
            <View style={styles.moreWrapper}>
              <Icons.MoreItems showMore={showMore} message={message} />
            </View>
          ) : null}
        </View>
      </Collapsible>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    fontFamily:  Platform.select({ default: "Nunito", android: "Nunito-SemiBold" }),
    fontWeight: "bold",
    fontSize: 20,
    lineHeight: 30,
    paddingLeft: 14,
    paddingTop: 10,
    display: "flex",
    alignItems: "center",
    letterSpacing: 1,
    color: "#333",
  },
  listContainer: {
    position: "relative",
    width: "100%",
    height: "auto",
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    borderWidth: 0,
  },
  moreWrapper: {
    paddingLeft: 15,
    marginTop: 10,
  },
});
